import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ResetPassword = () => {

  const { token } = useParams();

  const navigate = useNavigate();

  const [password, setPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");

  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const handleReset = async () => {

    if (password.length < 6) {
      setMessage("Password must be at least 6 characters");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {

      setLoading(true);

      const res = await fetch(
        "https://sangitshreeprakashan.com/backend/api/reset_password.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            token,
            password,
            confirm_password: confirmPassword
          })
        }
      );

      const data = await res.json();

      setMessage(data.message);

      if (data.status === "success") {

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      }

    } catch (err) {

      setMessage("Something went wrong");

    } finally {

      setLoading(false);
    }
  };

  return (
    <>
<style>
{`
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

*{
  box-sizing:border-box;
}

body{
  margin:0;
  font-family:'Poppins',sans-serif;
  background:#F1F3F6;
}

.reset-wrapper{
  min-height:100vh;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:20px;
  background:#F1F3F6;
}

.reset-card{
  width:100%;
  max-width:430px;
  background:#fff;
  padding:38px 30px;
  border-radius:22px;
  box-shadow:0 8px 32px rgba(40,116,240,0.15);
  animation:fadeUp .35s ease;
}

.reset-title{
  font-size:32px;
  font-weight:700;
  color:#2874F0;
  text-align:center;
  margin-bottom:10px;
}

.reset-subtitle{
  text-align:center;
  color:#666;
  margin-bottom:30px;
  font-size:14px;
  line-height:1.6;
}

.reset-input{
  width:100%;
  padding:14px 16px;
  border:1px solid #E0E0E0;
  border-radius:10px;
  outline:none;
  margin-bottom:18px;
  font-size:15px;
  transition:.25s ease;
  background:#fff;
}

.reset-input:focus{
  border-color:#2874F0;
  box-shadow:0 0 0 3px rgba(40,116,240,0.12);
}

.reset-btn{
  width:100%;
  padding:14px;
  border:none;
  border-radius:10px;
  background:#2874F0;
  color:#fff;
  font-size:16px;
  font-weight:600;
  cursor:pointer;
  transition:.25s ease;
}

.reset-btn:hover{
  background:#1565C0;
}

.reset-btn:disabled{
  opacity:.7;
  cursor:not-allowed;
}

.reset-message{
  margin-top:18px;
  text-align:center;
  font-size:14px;
  padding:12px;
  border-radius:10px;
  line-height:1.5;
}

.reset-message.success{
  background:#E8F5E9;
  color:#2E7D32;
  border:1px solid #C8E6C9;
}

.reset-message.error{
  background:#FFEBEE;
  color:#C62828;
  border:1px solid #FFCDD2;
}

@keyframes fadeUp{
  from{
    opacity:0;
    transform:translateY(15px);
  }
  to{
    opacity:1;
    transform:translateY(0);
  }
}

@media(max-width:480px){

  .reset-card{
    padding:30px 22px;
    border-radius:18px;
  }

  .reset-title{
    font-size:26px;
  }

  .reset-subtitle{
    font-size:13px;
  }
}
`}
</style>

      <div className="reset-wrapper">

        <div className="reset-card">

          <div className="reset-title">
            Reset Password
          </div>

          <div className="reset-subtitle">
            Enter your new password below
          </div>

          <input
            type="password"
            className="reset-input"
            placeholder="New Password"
            value={password}
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <input
            type="password"
            className="reset-input"
            placeholder="Confirm Password"
            value={confirmPassword}
            autoComplete="new-password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          <button
            className="reset-btn"
            onClick={handleReset}
            disabled={loading}
          >
            {loading ? "Updating..." : "Reset Password"}
          </button>

          {message && (
            <div className="reset-message">
              {message}
            </div>
          )}

        </div>

      </div>
    </>
  );
};

export default ResetPassword;